var _a;
import { Home } from "../pages/home";
import { Tax } from "@/pages/tax";
export var ROUTES;
(function (ROUTES) {
    ROUTES["HOME"] = "/";
    ROUTES["SOLICITACAO_CRIADA"] = "/solicitacao-criada";
})(ROUTES || (ROUTES = {}));
export var Routes = (_a = {},
    _a[ROUTES.SOLICITACAO_CRIADA] = Tax,
    _a[ROUTES.HOME] = Home,
    _a);
